import { all, takeLatest } from 'redux-saga/effects';
import { DashboardAsyncActions } from 'store/actions/dashboard';
import fetch from './fetch';

export default function* root() {
  const { FetchDashboard } = DashboardAsyncActions;
  yield all([takeLatest(FetchDashboard.Types.REQUEST, fetch)]);
}
